module.exports = __webpack_public_path__ + "img/pdf.a253c805.svg";